<template>
    <tr>
        <td>
            <checkbox :init-checked="isSelected" @change="actionChangeCheckbox"/>
        </td>
        <td v-text="email"></td>
        <td v-text="firstName"></td>
        <td v-text="lastName"></td>
        <td class="center">
            <div v-if="isActive" class="badge success">Active</div>
            <div v-else class="badge error">Unactive</div>
        </td>
        <td class="center access-item">
            <span v-if="hasAccessCompliance === null">-</span>
            <template v-else-if="hasAccessCompliance">
                <img src="../../assets/images/check-icon-green.svg" alt="">
                <text-button label="Unpair" class="small" @click="actionUnpair(compliancePlatformSlug)"/>
            </template>
            <template v-else-if="!hasAccessCompliance">
                <img src="../../assets/images/x-icon-red.svg" alt="">
                <text-button label="Pair" class="small" @click="actionShowPairModal(compliancePlatformSlug)"/>
                <admin-account-pair-modal :user-model="data" :platform-slug="compliancePlatformSlug"/>
            </template>
        </td>
        <td class="center access-item">
            <span v-if="hasAccessDfs === null">-</span>
            <template v-else-if="hasAccessDfs">
                <img src="../../assets/images/check-icon-green.svg" alt="">
                <text-button label="Unpair" class="small" @click="actionUnpair(dfsPlatformSlug)"/>
            </template>
            <template v-else-if="!hasAccessDfs">
                <img src="../../assets/images/x-icon-red.svg" alt="">
                <text-button label="Pair" class="small" @click="actionShowPairModal(dfsPlatformSlug)"/>
                <admin-account-pair-modal :user-model="data" :platform-slug="dfsPlatformSlug"/>
            </template>
        </td>
        <td class="center access-item">
            <span v-if="hasAccessAcademy === null">-</span>
            <template v-else-if="hasAccessAcademy">
                <img src="../../assets/images/check-icon-green.svg" alt="">
                <text-button label="Unpair" class="small" @click="actionUnpair(academyPlatformSlug)"/>
            </template>
            <template v-else-if="!hasAccessAcademy">
                <img src="../../assets/images/x-icon-red.svg" alt="">
                <text-button label="Pair" class="small" @click="actionShowPairModal(academyPlatformSlug)"/>
                <admin-account-pair-modal :user-model="data" :platform-slug="academyPlatformSlug"/>
            </template>
        </td>
    </tr>
</template>

<script>
    import Checkbox from "../components/Checkbox";
    import TextButton from "../components/TextButton";
    import {mapGetters, mapMutations} from "vuex";
    import AdminAccountPairModal from "../modals/AdminAccountPairModal";

    export default {
        name: "AccountUnificationItem",
        components: {AdminAccountPairModal, TextButton, Checkbox},
        props: {
            initData: {
                type: Object,
                required: true,
            }
        },
        computed: {
            isSelected() {
                return this.selectedItems.find(selectedItem => {
                    return selectedItem.id === this.id;
                }) !== undefined;
            },
            id() {
                return this.data.id ?? 0;
            },
            email() {
                return this.data.email ?? '-';
            },
            firstName() {
                return this.data.first_name ?? '-';
            },
            lastName() {
                return this.data.last_name ?? '-';
            },
            isActive() {
                return this.data.active ?? false;
            },
            hasAccessCompliance() {
                return this.data.compliance ?? null;
            },
            hasAccessDfs() {
                return this.data.dfs ?? null;
            },
            hasAccessAcademy() {
                return this.data.academy ?? null;
            },
            compliancePlatformSlug() {
                return this.$enums.PlatformSlugEnum.COMPLIANCE;
            },
            dfsPlatformSlug() {
                return this.$enums.PlatformSlugEnum.DFS;
            },
            academyPlatformSlug() {
                return this.$enums.PlatformSlugEnum.ACADEMY;
            },
            ...mapGetters('app', {
                selectedItems: 'getSelectedItems',
            })
        },
        data() {
            return {
                data: this.initData,
            }
        },
        methods: {
            actionShowPairModal(platformSlug) {
                let modalName = this.$enums.ModalNameEnum.ADMIN_ACCOUNT_PAIR + '-' + platformSlug + '-' + this.id;
                this.$modals.show(modalName);
            },
            actionChangeCheckbox(value) {
                if (value) {
                    this.addSelectedItem(this.data);
                } else {
                    this.removeSelectedItem(this.data);
                }
            },
            actionUnpair(platformSlug) {
                this.$api.unpairAccount({
                    data: {
                        app: platformSlug,
                        authId: this.id,
                    }
                }).then(() => {
                    switch (platformSlug) {
                        case this.$enums.PlatformSlugEnum.COMPLIANCE:
                            this.data.compliance = false;
                            break;
                        case this.$enums.PlatformSlugEnum.DFS:
                            this.data.dfs = false;
                            break;
                        case this.$enums.PlatformSlugEnum.ACADEMY:
                            this.data.academy = false;
                            break;
                    }
                })
            },
            ...mapMutations('app', {
                addSelectedItem: 'addSelectedItem',
                removeSelectedItem: 'removeSelectedItem',
            })
        },
        watch: {
            initData(value) {
                this.data = value;
            }
        }
    }
</script>

<style lang="scss" scoped>
    td.access-item {
        padding: 0;
        width: 60px;

        .text-button {
            display: none;
        }

        &:hover {
            & > img {
                display: none;
            }

            & > .text-button {
                display: inline-flex;
            }
        }
    }
</style>